import React from 'react';
import '../index.css';
const DetailsTab = ({ bar }) => {
  return (
    <div className="details-tab">
      {bar.website_url && (
        <a href={bar.website_url} target="_blank" rel="noopener noreferrer" className="bar-website">
          Visit Website
        </a>
      )}
      <div className="modal-body">
      <div className="columns-container">
        <div className="hours-column">
          <h3 className="column-header">Hours of Operation</h3>
          {bar.hoursOfOperation &&
            Object.entries(bar.hoursOfOperation).map(([day, hours]) => (
              <div key={day} className="bar-hours">
                <span className="day-text">{day.charAt(0).toUpperCase() + day.slice(1)}:</span> {hours}
              </div>
            ))}
        </div>
        <div className="description-column">
          <h3 className="column-header">About</h3>
          <p className="bar-hours">{bar.description}</p>
        </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;